import { Box, Grid } from '@material-ui/core';
import SkeletonPulse from './SkeletonPulse';

const TableFlagSkeletonLoader = () => {
  const TableHeaderCell = ({ text }) => (
    <Box p={1}>{/* <TableHeaderText text={text} /> */}</Box>
  );

  const SkeletonCell = () => (
    <Box p={1}>
      <SkeletonPulse height="30" backgroundColor="#364250" />
    </Box>
  );

  const SkeletonRow = () => (
    <Grid container style={{ backgroundColor: '#28313b' }}>
      <Grid item xs={2} style={{ outline: '1px solid #ddd' }}>
        <SkeletonCell />
      </Grid>
      <Grid item xs={4} style={{ outline: '1px solid #ddd' }}>
        <SkeletonCell />
      </Grid>
      <Grid item xs={2} style={{ outline: '1px solid #ddd' }}>
        <SkeletonCell />
      </Grid>
      <Grid item xs={2} style={{ outline: '1px solid #ddd' }}>
        <SkeletonCell />
      </Grid>
      <Grid item xs={2} style={{ outline: '1px solid #ddd' }}>
        <SkeletonCell />
      </Grid>
    </Grid>
  );

  return (
    <Box mt={2}>
      <Grid
        container
        spacing={1}
        style={{ backgroundColor: '#28313b', outline: '1px solid #ddd' }}
      >
        <Grid item xs={2}></Grid>
        <Grid item xs={4}>
          <TableHeaderCell text="Document Name" />
        </Grid>
        <Grid item xs={2}>
          <TableHeaderCell text="Tag" />
        </Grid>
        <Grid item xs={2}>
          <TableHeaderCell text="Date" />
        </Grid>
        <Grid item xs={2}>
          <TableHeaderCell text="Dictaction" />
        </Grid>
        {Array.from({ length: 10 }, (_, index) => (
          <SkeletonRow key={index} />
        ))}
      </Grid>
    </Box>
  );
};

export default TableFlagSkeletonLoader;
